import { BcProductFragment } from 'lib/bigcommerce';
import { ProductData, ProductVariantData } from 'lib/bigcommerce/types';
import _ from 'lodash';
import { PurchaseType } from '../lib/bigcommerce/product-options';

export const applyTax = (amount) => amount * (1 + parseInt(process.env.BC_TAX_PERCENTAGE) / 100);

export const removeTax = (amount) =>
  (amount * (1 - parseInt(process.env.BC_TAX_PERCENTAGE) / 100)).toFixed(2);

export const extractProductCustomFieldValue = (
  fieldName: string,
  customFields: BcProductFragment['customFields']
) => {
  return customFields.edges.find((z) => z.node.name === fieldName)?.node.value || null;
};

export const calculateSubscriptionsSaving = (
  subscriptionVariant: ProductVariantData,
  oneOffVariant: ProductVariantData
) => {
  if (!oneOffVariant || !subscriptionVariant) return null;

  const oneOffPrice = oneOffVariant.salePrice || oneOffVariant.price;
  const subPrice = subscriptionVariant.salePrice || subscriptionVariant.price;

  if (subPrice > oneOffPrice) return null;

  const percent = 100 - Math.round((100 * subPrice) / oneOffPrice);

  if (!(percent >= 1)) return null;

  const rounded = percent - (percent % 1);
  return `${rounded}%`;
};

export const getAdded = (base, current) =>
  current?.items?.filter((item) => !base.items.some((i) => i.productId === item.productId));

export const getRemoved = (base, current) =>
  base.items.filter((item) => !current.items.some((i) => i.id === item.id));

export const getModified = (base, current) =>
  base.id === current.id
    ? current.items
        .filter((item) => base.items.some((i) => i.productId === item.productId))
        .filter(
          (item) =>
            !_.isEqual(
              item,
              base.items.find((bItem) => bItem.id === item.id)
            )
        )
    : [];

export const extractSubscriptionPrice: (product: ProductData) => ProductData = (product) => {
  const subscriptionProduct = product.variants.find(
    (x) => x.purchaseType.id === PurchaseType.Subscription.id
  );

  return {
    ...product,
    sku: subscriptionProduct.sku,
    variantId: subscriptionProduct.entityId,
    price: subscriptionProduct.price || product.price,
  };
};

export const normalizeProductsSubscriptionAddItem: (products: ProductData[]) => ProductData[] = (
  products
) => {
  return products.map((product) => extractSubscriptionPrice(product));
};
